import { useState } from "react";
import styled from "styled-components";
import { useClickOutside } from "webrix/hooks";

const Wrapper = styled.div`
  width: 36px;
  height: 36px;
  font-size: 14px;
  position: relative;
  
  input {
    border: 1px solid var(--grey_10);
    cursor: pointer;
    border-radius: 6px;
    text-align: center;
    height: 100%;
    width: 100%;
    outline: none;
  }

  .list {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05),
      0px 25px 35px rgba(0, 0, 0, 0.03);
    position: absolute;
    max-height: 240px;
    width: 72px;
    right: 0;
    background-color: #fff;
    z-index: 2;
    top: calc(100% + 3px);
    border-radius: 8px;
    overflow: auto;
  }

  .list_Item {
    width: 100%;
    padding: 12px;
    color: var(--grey_1);
    &:hover {
      background-color: var(--background);
    }
  }
`;

const ScheduleDropdown = ({ list, value, setValue }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelect = (e, l) => {
    e.preventDefault();
    e.stopPropagation();
    setValue(l);
    setShowDropdown(false);
  };

  const handleMouseDownCapture = useClickOutside(() => setShowDropdown(false));

  return (
    <Wrapper
      onMouseDownCapture={handleMouseDownCapture}
      onClick={() => setShowDropdown(true)}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        className="selectInput"
        readOnly
      />

      {showDropdown && (
        <div className="list">
          {list?.map((item) => (
            <button
              key={item}
              type="button"
              className={`list_Item`}
              onClick={(e) => handleSelect(e, item?.toString())}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </Wrapper>
  );
};

export default ScheduleDropdown;
